<!-- 顶部提示信息 -->
<div [ngClass]="CLASS_NAME_OF_TIPS_OVER_HEADER" *ngIf="!SWITCH.IS_VIRTUAL_MACHINE_CONSOLE">
    <!-- 开局模式告警 -->
    <app-deployment-mode *ngIf="SWITCH.SUPPORT_DEPLOYMENT_MODE_WARNING && !isLoginPage && !isPoweronFailPage && !SWITCH.IS_VSTORE_SYSTEM && !isOem && hasCallhomeR"
        [ngClass]="{'deployment-mode-warning-is-auto-in-simple': isAutoInSimple}"></app-deployment-mode>

    <!-- DME IQ远程连接 -->
    <app-remote-assistance *ngIf="!isLoginPage && !isInitializePage && !isPoweronFailPage
        && !SWITCH.IS_VSTORE_SYSTEM && !isOem && hasCallhomeR && !isRemoteAssistanceUser">
    </app-remote-assistance>

    <!-- 质检栏 -->
    <app-quality-inspect></app-quality-inspect>
</div>

<app-header class="width-change-transition" [id]="isAutoInSimple ? 'app-header-simple-initialize' : 'app-header'"
    [ngClass]="{'hide-header': isLoginPage || (isSimpleMode === undefined)}"
    [isSimpleMode]="isSimpleMode || isAutoInSimple"
    [ngStyle]="{'width': dynamicWidth}"
    *ngIf="!SWITCH.IS_VIRTUAL_MACHINE_CONSOLE">
</app-header>

<ng-container *ngIf="isLoginPage">
    <div *ngIf="!SUPPORT_JA_LAN" class="language-box language-div"
        (click)="changeLan()">
        <span>{{language}}</span>
    </div>
    <div *ngIf="SUPPORT_JA_LAN" class="language-box language-div">
        <app-header-language></app-header-language>
    </div>
    <div class="copyrightDiv"
        id="copyrightDiv">
        <span class="pre-wrap">{{copyright}}</span>
    </div>
</ng-container>

<app-smart-assistant class="smart-assistant" *ngIf="showSmartAssistant" [ngStyle]="{'width': ASSISTANT_WIDTH}"></app-smart-assistant>

<section class="content width-change-transition" [ngStyle]="{'width': dynamicWidth}">
    <router-outlet></router-outlet>
</section>

<app-login-info></app-login-info>

<ng-template #zoomDontPrompt>
    <div [ngClass]="{'notShowAgain-checkbox':true}">
        <n-checkbox id="dontPrompt"
            [label]="noNoticeAgain"
            [(ngModel)]="dontPrompt">
        </n-checkbox>
    </div>
</ng-template>
